import { useQuery } from '@tanstack/react-query';

/**
 * Hook to get token price from DexScreener API
 * Falls back to 0 if price unavailable
 */
export const useTokenPrice = (tokenAddress, chainId = 'bsc') => {
  return useQuery({
    queryKey: ['tokenPrice', tokenAddress, chainId],
    queryFn: async () => {
      if (!tokenAddress) return 0;

      try {
        // Try DexScreener API first
        const response = await fetch(
          `https://api.dexscreener.com/latest/dex/tokens/${tokenAddress}`
        );
        
        if (!response.ok) {
          console.warn(`DexScreener API failed for ${tokenAddress}`);
          return 0;
        }

        const data = await response.json();
        
        // Get the first pair (usually most liquid)
        if (data.pairs && data.pairs.length > 0) {
          const pair = data.pairs[0];
          const price = parseFloat(pair.priceUsd);
          
          if (!isNaN(price) && price > 0) {
            return price;
          }
        }

        return 0;
      } catch (error) {
        console.error(`Error fetching price for ${tokenAddress}:`, error);
        return 0;
      }
    },
    enabled: !!tokenAddress,
    staleTime: 60000, // 1 minute
    refetchInterval: 60000, // Refetch every minute
    refetchOnWindowFocus: true,
    retry: 2,
    // Return 0 on error instead of throwing
    onError: (error) => {
      console.warn('Token price fetch error:', error);
    }
  });
};

export default useTokenPrice;
